import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

/**
 * Check-in / check-out helpers. The backend stores these as free 12-hour strings
 * ("3:00 PM"), while the native <input type="time"> works in 24-hour "HH:mm".
 * These convert between the two so every add/edit surface can use the native
 * browser time picker yet still persist the canonical "h:mm A" shape.
 */
const STORED_FORMATS = ["h:mm A", "hh:mm A", "h:mmA", "hh:mmA", "H:mm", "HH:mm"];

/** Any stored/display time → native <input type="time"> value (24h "HH:mm"). "" if unparseable. */
export const toTimeInputValue = (v?: string | null): string => {
  if (!v) return "";
  const d = dayjs(String(v).trim(), STORED_FORMATS, true);
  return d.isValid() ? d.format("HH:mm") : "";
};

/** Native time value (24h "HH:mm") → backend "h:mm A" ("3:00 PM"). "" if empty/unparseable. */
export const fromTimeInputValue = (v?: string | null): string => {
  if (!v) return "";
  const d = dayjs(String(v).trim(), ["HH:mm", "H:mm"], true);
  return d.isValid() ? d.format("h:mm A") : "";
};

/** Normalize any stored time to the backend's canonical "h:mm A"; keeps the original if unparseable. */
export const normalizeTimeForBackend = (v?: string | null): string => {
  const native = toTimeInputValue(v);
  return native ? fromTimeInputValue(native) : v ?? "";
};
